import { render, staticRenderFns } from "./ClientBox.vue?vue&type=template&id=d6334d64&scoped=true&"
import script from "./ClientBox.vue?vue&type=script&lang=js&"
export * from "./ClientBox.vue?vue&type=script&lang=js&"
import style0 from "./ClientBox.vue?vue&type=style&index=0&id=d6334d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6334d64",
  null
  
)

export default component.exports